import { render, staticRenderFns } from "./SearchConfigs.vue?vue&type=template&id=632c0667"
import script from "./SearchConfigs.vue?vue&type=script&lang=js"
export * from "./SearchConfigs.vue?vue&type=script&lang=js"
import style0 from "./SearchConfigs.vue?vue&type=style&index=0&id=632c0667&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports